import type {ReactNode} from 'react';
import {useSearchParams} from 'react-router-dom';
import type {TreeResponse} from 'src/api/ProactApiClient';
import {withNodeSearchParam} from 'src/app/tree-browser/treeBrowserUtils';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {AssetTreeBrowser} from './AssetTreeBrowser';
import {assetTreeKinds, assetTreeRootId} from './assetTreeBrowserState';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

const assetDefaultView = 'overview';

export interface AssetsBrowserShellProps {
  /** Tree node id of the asset or group the page is showing; undefined until the record loads. */
  selectedId?: string;
  children: ReactNode;
}

/** Asset group pane plus the module's node-select navigation, for every Assets route. */
export const AssetsBrowserShell = ({
  selectedId,
  children,
}: AssetsBrowserShellProps) => {
  const navigate = useAppNavigate();
  const [searchParams] = useSearchParams();

  const handleSelect = (nodeId: string, node?: TreeResponse) => {
    if (node?.kind === assetTreeKinds.asset) {
      navigate(PathUtility.AssetView(nodeId, assetDefaultView));
      return;
    }
    const next = withNodeSearchParam(searchParams, nodeId, assetTreeRootId);
    navigate({pathname: PathUtility.Assets(), search: next.toString()});
  };

  return (
    <AssetTreeBrowser selectedId={selectedId} onSelect={handleSelect}>
      {children}
    </AssetTreeBrowser>
  );
};
